import React from 'react';

// === components ===
import { Main } from 'src/components';

const HomePage: React.FC = () => {
  return <Main />;
};

export default HomePage;
